import React from 'react';
import { WeaAlertPage, WeaLocaleProvider } from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export default () => (
    <WeaAlertPage ecId={`${this && this.props && this.props.ecId || ''}_WeaAlertPage@wms00p`} >
        <div style={{ color: '#000' }}>
            {getLabel(530230,'对不起，存在加密,脱敏信息,您暂时没有权限！请联系管理员')}
        </div>
    </WeaAlertPage>
)


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/pages/no-right/encrypt.tsx